// Considera 0 cualquier valor con |n| < epsilon. Evita que errores de
// punto flotante produzcan `-0`, `-0,0%` o `-0,01 €` que luego se pintan
// en rojo confundiendo al usuario.
export const ZERO_EPS = 0.005;

export const normalizeZero = (n) => (typeof n === 'number' && Math.abs(n) < ZERO_EPS ? 0 : n);

export const formatUnits = (n) => Intl.NumberFormat('es-Es').format(Math.round(normalizeZero(Number(n) || 0)));

// Locale apropiado a cada moneda — coloca el símbolo en su lado natural
// (€ a la derecha en es-ES, $ a la izquierda en es-MX) en vez de salir
// como prefijo ISO `EUR 1.234`.
export const localeForCurrency = (code) => {
  switch (String(code || '').toUpperCase()) {
    case 'EUR':
      return 'es-ES';
    case 'USD':
      return 'en-US';
    case 'MXN':
    default:
      return 'es-MX';
  }
};

export const formatMoney = (n, currency) =>
  Intl.NumberFormat(localeForCurrency(currency.symbol), {
    style: 'currency',
    currency: currency.symbol,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(normalizeZero((Number(n) || 0) * currency.exchange));

export const formatPct = (n) => {
  if (n === null || n === undefined) return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  // -0.0001 → 0 para evitar "-0,0%" en pantalla. Epsilon más fino que en
  // dinero porque los porcentajes ya están en escala 0..1.
  const normalized = Math.abs(v) < 0.00005 ? 0 : v;
  return `${(normalized * 100).toFixed(1)}%`;
};

// Detecta si un valor ya formateado representa un negativo. Funciona para
// monedas (`-1.234,56 €`), unidades (`-123`) y porcentajes (`-12.3%`). El
// guión menos puede llegar como `-` ASCII o como `−` Unicode (Intl puede
// usar este último en algunos locales/navegadores).
export const isFormattedNegative = (str) => /^\s*[−-]/.test(String(str));

export const isNeg = (v) => typeof v === 'number' && Number.isFinite(v) && v < -ZERO_EPS;

export const div = (a, b) => (b > 0 ? a / b : null);
